import { http } from '../../config/axios'

 const findResultadoMotorCredito = (params:any): Promise<any> => {
  const queryParams = params
                ? Object.keys(params)
                      .map((k) => encodeURIComponent(params[k]))
                      .join('/')
                : '';
  return http
    .get('api/resultadomotorcredito/find/' + queryParams)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findResultadoMotorCredito', error)
      throw Error(error.response.data)
    })
}

export default findResultadoMotorCredito;
